import React from "react"
import PropTypes from "prop-types"

const ColumnControls = ({
  onMoveAllToLeft,
  onMoveAllToRight,
  onMoveToRight,
  onMoveToLeft,
  elements,
  selectedModules = [],
}) => {
  const canMoveAllToLeft = elements.some((element) => element?.active === 1)
  const canMoveAllToRight = elements.some((element) => element?.active === 0)
  const canMoveToRight = selectedModules.some((module) => module?.active === 1)
  const canMoveToLeft = selectedModules.some((module) => module?.active === 0)
  return (
    <div className="p-picklist-buttons p-picklist-transfer-buttons flex gap-2 flex-row flex-row lg:flex-column">
      <button
        type="button"
        className={`p-button p-component p-button-icon-only ${canMoveToRight ? "" : "p-disabled"} lg:-rotate-90`}
        disabled=""
        onClick={onMoveToRight}
      >
        <span className="p-button-icon p-c pi pi-angle-down"></span>
        <span className="p-button-label p-c">&nbsp;</span>
        <span role="presentation" className="p-ink"></span>
      </button>
      <button
        type="button"
        className={`p-button p-component p-button-icon-only ${canMoveAllToLeft ? "" : "p-disabled"} lg:-rotate-90`}
        onClick={onMoveAllToRight}
      >
        <span className="p-button-icon p-c pi pi-angle-double-down"></span>
        <span className="p-button-label p-c">&nbsp;</span>
        <span role="presentation" className="p-ink"></span>
      </button>
      <button
        type="button"
        className={`p-button p-component p-button-icon-only ${canMoveToLeft ? "" : "p-disabled"} lg:-rotate-90`}
        disabled=""
        onClick={onMoveToLeft}
      >
        <span className="p-button-icon p-c pi pi-angle-up"></span>
        <span className="p-button-label p-c">&nbsp;</span>
        <span role="presentation" className="p-ink"></span>
      </button>
      <button
        type="button"
        className={`p-button p-component p-button-icon-only ${canMoveAllToRight ? "" : "p-disabled"} lg:-rotate-90`}
        disabled=""
        onClick={onMoveAllToLeft}
      >
        <span className="p-button-icon p-c pi pi-angle-double-up"></span>
        <span className="p-button-label p-c">&nbsp;</span>
        <span role="presentation" className="p-ink"></span>
      </button>
    </div>
  )
}

export default ColumnControls

ColumnControls.propTypes = {
  onMoveAllToLeft: PropTypes.func,
  onMoveAllToRight: PropTypes.func,
  onMoveToRight: PropTypes.func,
  onMoveToLeft: PropTypes.func,
  elements: PropTypes.array,
  selectedModules: PropTypes.array,
}
